const CookieDevTools = () => {

  return (
    <div style={{ textAlign: 'left' }}>
        <h1>Browser DevTools: Cookies</h1>
        <p>This site sets a cookie to your browser named "se_test"</p>
        <p>Using your browser dev tools, find the "se_test" cookie and paste the value in the text box on the right.</p>
    </div>
  )

}

export default CookieDevTools;